import React from 'react'
import {connect} from 'react-redux'

class GoToSessionButton extends React.Component {
  sessionUrl () {
    return `${this.props.sessionsUrl}?sessionId=${this.props.sessionId}`
  }

  render () {
    return (
      <a href={this.sessionUrl()} target='_blank' className={this.props.classNames} style={this.props.style}>
        {this.props.text ? this.props.text : 'Go to your session'}
      </a>
    )
  }
}

GoToSessionButton.defaultProps = {
  classNames: 'button success'
}

const mapStateToProps = (state) => {
  return {
    sessionsUrl: state.getIn(['pluginSettings', 'sessionsUrl'])
  }
}

const GoToSessionButtonContainer = connect(
  mapStateToProps
)(GoToSessionButton)

export default GoToSessionButtonContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/go_to_session_button.js
 **/